// This file is auto-generated. Do not edit manually.
    import { PropertyType } from "@/app/[locale]/(public)/rent/[locationSlug]/_components/property-type/utils";
  export const rentPropertyTypes: Record<string, Partial<Record<PropertyType, number>>> = {
  "alkmaar": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 8,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 7,
    "furnished-apartment": 5,
    "green-energy-apartment": 9,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 12
  },
  "almelo": {
    "family-house": 6,
    "house-for-rent": 6,
    "unfurnished-house": 6
  },
  "almere": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 7,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 12,
    "apartment-with-elevator": 9,
    "apartment-with-security": 5,
    "family-house": 11,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 11,
    "furnished-house": 7,
    "furnished-house-with-garden": 7,
    "furnished-room": 14,
    "green-energy-apartment": 14,
    "green-energy-house": 9,
    "green-energy-room": 10,
    "house-for-rent": 11,
    "house-with-garden": 11,
    "renovated-apartment": 5,
    "room-for-students": 18,
    "student-housing": 23,
    "unfurnished-apartment": 13,
    "unfurnished-room": 8
  },
  "alphen-aan-den-rijn": {
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 7,
    "green-energy-apartment": 7,
    "unfurnished-apartment": 8
  },
  "amersfoort": {
    "2-bedroom-apartment": 10,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "apartment-with-private-parking": 7,
    "family-house": 6,
    "furnished-house": 5,
    "furnished-house-with-garden": 5,
    "green-energy-apartment": 7,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "student-housing": 5,
    "unfurnished-apartment": 12
  },
  "amstelveen": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "3-bedroom-apartment": 7,
    "3-bedroom-house": 6,
    "apartment-with-balcony": 13,
    "apartment-with-elevator": 7,
    "apartment-with-private-parking": 5,
    "family-house": 11,
    "furnished-apartment": 7,
    "furnished-room": 7,
    "green-energy-apartment": 16,
    "green-energy-house": 10,
    "green-energy-room": 6,
    "house-for-rent": 11,
    "house-with-garden": 7,
    "room-for-students": 12,
    "student-housing": 15,
    "unfurnished-apartment": 13,
    "unfurnished-house": 10,
    "unfurnished-room": 7
  },
  "amsterdam": {
    "1-bedroom-apartment": 146,
    "2-bedroom-apartment": 230,
    "2-bedroom-house": 6,
    "3-bedroom-apartment": 63,
    "3-bedroom-house": 10,
    "4-bedroom-apartment": 9,
    "apartment-with-balcony": 269,
    "apartment-with-elevator": 117,
    "apartment-with-garden": 45,
    "apartment-with-laundry": 25,
    "apartment-with-private-parking": 64,
    "apartment-with-security": 19,
    "family-house": 22,
    "flat-for-students": 106,
    "furnished-1-bedroom-apartment": 70,
    "furnished-apartment": 191,
    "furnished-house": 10,
    "furnished-room": 164,
    "furnished-studio": 29,
    "green-energy-apartment": 327,
    "green-energy-house": 14,
    "green-energy-room": 73,
    "green-energy-studio": 41,
    "house-for-rent": 24,
    "house-with-garden": 13,
    "newly-built-apartment": 10,
    "pet-friendly-apartment": 31,
    "renovated-apartment": 44,
    "room-for-students": 126,
    "room-with-laundry": 9,
    "student-housing": 235,
    "studio-for-rent": 59,
    "studio-with-balcony": 11,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 279,
    "unfurnished-house": 14,
    "unfurnished-room": 19,
    "unfurnished-studio": 30
  },
  "apeld-centrum": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 8,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 11
  },
  "apeld-zuidoost": {
    "1-bedroom-apartment": 8,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 5,
    "unfurnished-apartment": 10
  },
  "apeldoorn": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 16,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 23,
    "apartment-with-elevator": 19,
    "apartment-with-private-parking": 6,
    "family-house": 11,
    "green-energy-apartment": 28,
    "green-energy-house": 10,
    "house-for-rent": 11,
    "house-with-garden": 11,
    "unfurnished-apartment": 35,
    "unfurnished-house": 11,
    "unfurnished-room": 5
  },
  "arnhe-centrum": {
    "student-housing": 6
  },
  "arnhem": {
    "1-bedroom-apartment": 9,
    "2-bedroom-apartment": 14,
    "apartment-with-balcony": 12,
    "apartment-with-elevator": 6,
    "apartment-with-private-parking": 6,
    "flat-for-students": 6,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 11,
    "furnished-room": 16,
    "green-energy-apartment": 17,
    "green-energy-room": 9,
    "renovated-apartment": 8,
    "room-for-students": 33,
    "student-housing": 39,
    "studio-for-rent": 6,
    "unfurnished-apartment": 18,
    "unfurnished-room": 23
  },
  "assen": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 6,
    "green-energy-apartment": 6,
    "unfurnished-apartment": 10
  },
  "bergen-op-zoom": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 14,
    "apartment-with-elevator": 5,
    "family-house": 5,
    "green-energy-apartment": 7,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 12
  },
  "bergpolder": {
    "1-bedroom-apartment": 6,
    "apartment-with-balcony": 10,
    "flat-for-students": 5,
    "student-housing": 9,
    "unfurnished-apartment": 10
  },
  "blijdorp": {
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 9,
    "unfurnished-apartment": 8
  },
  "bloemhof": {
    "apartment-with-balcony": 6,
    "furnished-apartment": 5,
    "student-housing": 8
  },
  "bospolder": {
    "room-for-students": 5,
    "student-housing": 7
  },
  "breda": {
    "1-bedroom-apartment": 22,
    "2-bedroom-apartment": 27,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 35,
    "apartment-with-elevator": 27,
    "apartment-with-private-parking": 11,
    "family-house": 15,
    "flat-for-students": 14,
    "furnished-apartment": 7,
    "furnished-room": 5,
    "green-energy-apartment": 26,
    "green-energy-house": 9,
    "green-energy-room": 6,
    "house-for-rent": 16,
    "house-with-garden": 14,
    "room-for-students": 31,
    "student-housing": 45,
    "studio-for-rent": 14,
    "unfurnished-apartment": 51,
    "unfurnished-house": 13,
    "unfurnished-room": 29,
    "unfurnished-studio": 10
  },
  "brunssum": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "unfurnished-apartment": 8
  },
  "capelle-aan-den-ijssel": {
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 6,
    "flat-for-students": 5,
    "furnished-apartment": 5,
    "furnished-room": 12,
    "green-energy-apartment": 7,
    "room-for-students": 8,
    "student-housing": 13,
    "unfurnished-apartment": 5
  },
  "carnisse": {
    "furnished-room": 11,
    "room-for-students": 11,
    "student-housing": 11
  },
  "centr-bergen": {
    "flat-for-students": 5,
    "furnished-room": 5,
    "room-for-students": 16,
    "student-housing": 21,
    "studio-for-rent": 6,
    "unfurnished-room": 11
  },
  "centr-binnenstad-noord": {
    "room-for-students": 7,
    "student-housing": 7,
    "unfurnished-room": 10
  },
  "centr-binnenstad-zuid": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "flat-for-students": 5,
    "renovated-apartment": 6,
    "room-for-students": 5,
    "student-housing": 10,
    "studio-for-rent": 5,
    "unfurnished-apartment": 11
  },
  "centr-fellenoord": {
    "green-energy-room": 6,
    "room-with-laundry": 5,
    "student-housing": 5
  },
  "centrum-rcigi": {
    "unfurnished-apartment": 5
  },
  "charlois": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 14,
    "apartment-with-balcony": 12,
    "apartment-with-elevator": 5,
    "flat-for-students": 6,
    "furnished-apartment": 6,
    "furnished-room": 16,
    "room-for-students": 19,
    "student-housing": 25,
    "unfurnished-apartment": 17,
    "unfurnished-room": 5
  },
  "delfs-middelland": {
    "2-bedroom-apartment": 5,
    "furnished-apartment": 6,
    "student-housing": 7
  },
  "delft": {
    "1-bedroom-apartment": 19,
    "2-bedroom-apartment": 17,
    "3-bedroom-apartment": 7,
    "apartment-with-balcony": 25,
    "apartment-with-elevator": 18,
    "apartment-with-laundry": 6,
    "flat-for-students": 32,
    "furnished-apartment": 13,
    "furnished-room": 29,
    "furnished-studio": 7,
    "green-energy-apartment": 23,
    "green-energy-room": 6,
    "green-energy-studio": 11,
    "room-for-students": 44,
    "room-with-laundry": 11,
    "student-housing": 77,
    "studio-for-rent": 19,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 40,
    "unfurnished-room": 17,
    "unfurnished-studio": 12
  },
  "den-haag": {
    "1-bedroom-apartment": 100,
    "2-bedroom-apartment": 146,
    "3-bedroom-apartment": 43,
    "4-bedroom-apartment": 6,
    "apartment-with-balcony": 180,
    "apartment-with-elevator": 93,
    "apartment-with-garden": 25,
    "apartment-with-laundry": 35,
    "apartment-with-private-parking": 40,
    "apartment-with-security": 17,
    "family-house": 20,
    "flat-for-students": 50,
    "furnished-1-bedroom-apartment": 23,
    "furnished-apartment": 83,
    "furnished-house": 6,
    "furnished-house-with-garden": 6,
    "furnished-room": 33,
    "furnished-studio": 11,
    "green-energy-apartment": 185,
    "green-energy-house": 7,
    "green-energy-room": 7,
    "green-energy-studio": 17,
    "house-for-rent": 23,
    "house-with-garden": 19,
    "pet-friendly-apartment": 13,
    "renovated-apartment": 41,
    "room-for-students": 47,
    "student-housing": 97,
    "studio-for-rent": 34,
    "studio-with-laundry": 10,
    "unfurnished-apartment": 228,
    "unfurnished-house": 17,
    "unfurnished-room": 19,
    "unfurnished-studio": 23
  },
  "den-helder": {
    "3-bedroom-house": 5,
    "apartment-with-balcony": 7,
    "family-house": 6,
    "green-energy-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 8,
    "unfurnished-house": 6
  },
  "deven-binnenstad": {
    "student-housing": 6,
    "unfurnished-apartment": 6
  },
  "deventer": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 6,
    "apartment-with-balcony": 9,
    "family-house": 8,
    "green-energy-apartment": 5,
    "green-energy-room": 5,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "room-for-students": 9,
    "student-housing": 14,
    "unfurnished-apartment": 15,
    "unfurnished-house": 8,
    "unfurnished-room": 5
  },
  "diemen": {
    "2-bedroom-apartment": 10,
    "3-bedroom-apartment": 9,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 6,
    "furnished-room": 7,
    "green-energy-apartment": 20,
    "green-energy-room": 6,
    "room-for-students": 8,
    "student-housing": 9,
    "unfurnished-apartment": 19
  },
  "doetinchem": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 6,
    "family-house": 6,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 7,
    "unfurnished-house": 6
  },
  "dordrecht": {
    "2-bedroom-apartment": 8,
    "furnished-apartment": 7,
    "green-energy-apartment": 9,
    "unfurnished-apartment": 7
  },
  "drechterland": {
    "2-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "family-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-house": 5
  },
  "drenthe": {
    "1-bedroom-apartment": 18,
    "2-bedroom-apartment": 21,
    "2-bedroom-house": 14,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 21,
    "apartment-with-balcony": 29,
    "apartment-with-elevator": 16,
    "apartment-with-garden": 5,
    "family-house": 37,
    "furnished-apartment": 9,
    "green-energy-apartment": 28,
    "green-energy-house": 21,
    "green-energy-room": 5,
    "house-for-rent": 43,
    "house-with-garden": 41,
    "room-for-students": 19,
    "student-housing": 23,
    "unfurnished-apartment": 42,
    "unfurnished-house": 42,
    "unfurnished-room": 22
  },
  "edam-volendam": {
    "1-bedroom-apartment": 8,
    "family-house": 6,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 8,
    "green-energy-house": 5,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "unfurnished-house": 6
  },
  "ede": {
    "room-for-students": 8,
    "student-housing": 10,
    "unfurnished-room": 5
  },
  "eindh-centrum": {
    "1-bedroom-apartment": 13,
    "2-bedroom-apartment": 6,
    "apartment-with-elevator": 8,
    "apartment-with-laundry": 8,
    "flat-for-students": 48,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 12,
    "furnished-room": 42,
    "furnished-studio": 29,
    "green-energy-apartment": 11,
    "green-energy-room": 59,
    "green-energy-studio": 32,
    "room-for-students": 71,
    "room-with-laundry": 47,
    "student-housing": 119,
    "studio-for-rent": 40,
    "studio-with-laundry": 26,
    "studio-with-study-space": 10,
    "unfurnished-apartment": 9,
    "unfurnished-room": 31,
    "unfurnished-studio": 11
  },
  "eindhoven": {
    "1-bedroom-apartment": 113,
    "2-bedroom-apartment": 59,
    "2-bedroom-house": 7,
    "3-bedroom-apartment": 6,
    "3-bedroom-house": 11,
    "apartment-with-balcony": 66,
    "apartment-with-elevator": 32,
    "apartment-with-garden": 21,
    "apartment-with-laundry": 20,
    "apartment-with-private-parking": 35,
    "apartment-with-security": 5,
    "family-house": 23,
    "flat-for-students": 232,
    "furnished-1-bedroom-apartment": 56,
    "furnished-apartment": 85,
    "furnished-house": 8,
    "furnished-house-with-garden": 5,
    "furnished-room": 123,
    "furnished-studio": 67,
    "green-energy-apartment": 81,
    "green-energy-house": 12,
    "green-energy-room": 168,
    "green-energy-studio": 81,
    "house-for-rent": 28,
    "house-with-garden": 18,
    "renovated-apartment": 13,
    "room-for-students": 269,
    "room-with-laundry": 67,
    "student-housing": 505,
    "studio-for-rent": 148,
    "studio-with-balcony": 13,
    "studio-with-laundry": 62,
    "studio-with-study-space": 10,
    "unfurnished-apartment": 103,
    "unfurnished-house": 20,
    "unfurnished-room": 156,
    "unfurnished-studio": 81
  },
  "emmen": {
    "apartment-with-balcony": 7,
    "green-energy-apartment": 8,
    "room-for-students": 13,
    "student-housing": 14,
    "unfurnished-apartment": 10,
    "unfurnished-room": 13
  },
  "enkhuizen": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 17,
    "3-bedroom-house": 12,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 5,
    "apartment-with-garden": 7,
    "family-house": 15,
    "furnished-1-bedroom-apartment": 10,
    "furnished-apartment": 26,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "house-for-rent": 15,
    "house-with-garden": 13,
    "unfurnished-apartment": 7,
    "unfurnished-house": 6
  },
  "enschede": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 10,
    "3-bedroom-apartment": 8,
    "apartment-with-balcony": 11,
    "apartment-with-private-parking": 5,
    "family-house": 6,
    "flat-for-students": 22,
    "furnished-apartment": 5,
    "furnished-room": 34,
    "furnished-studio": 9,
    "green-energy-room": 27,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "room-for-students": 87,
    "room-with-laundry": 6,
    "student-housing": 111,
    "studio-for-rent": 18,
    "unfurnished-apartment": 24,
    "unfurnished-house": 7,
    "unfurnished-room": 64,
    "unfurnished-studio": 9
  },
  "flevoland": {
    "1-bedroom-apartment": 28,
    "2-bedroom-apartment": 23,
    "2-bedroom-house": 8,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 10,
    "apartment-with-balcony": 28,
    "apartment-with-elevator": 20,
    "apartment-with-garden": 13,
    "apartment-with-laundry": 6,
    "apartment-with-private-parking": 21,
    "apartment-with-security": 6,
    "family-house": 27,
    "flat-for-students": 11,
    "furnished-1-bedroom-apartment": 13,
    "furnished-apartment": 25,
    "furnished-house": 7,
    "furnished-house-with-garden": 7,
    "furnished-room": 17,
    "green-energy-apartment": 49,
    "green-energy-house": 15,
    "green-energy-room": 10,
    "green-energy-studio": 5,
    "house-for-rent": 27,
    "house-with-garden": 25,
    "house-with-private-parking": 10,
    "renovated-apartment": 6,
    "room-for-students": 22,
    "student-housing": 36,
    "studio-for-rent": 7,
    "unfurnished-apartment": 42,
    "unfurnished-house": 20,
    "unfurnished-room": 10
  },
  "frysln": {
    "1-bedroom-apartment": 32,
    "1-bedroom-house": 7,
    "2-bedroom-apartment": 39,
    "2-bedroom-house": 11,
    "3-bedroom-apartment": 11,
    "3-bedroom-house": 22,
    "apartment-with-balcony": 53,
    "apartment-with-elevator": 29,
    "apartment-with-garden": 13,
    "apartment-with-private-parking": 6,
    "family-house": 44,
    "flat-for-students": 9,
    "furnished-apartment": 8,
    "furnished-room": 7,
    "green-energy-apartment": 44,
    "green-energy-house": 28,
    "house-for-rent": 51,
    "house-with-garden": 50,
    "room-for-students": 20,
    "student-housing": 29,
    "studio-for-rent": 6,
    "unfurnished-apartment": 77,
    "unfurnished-house": 49,
    "unfurnished-room": 15,
    "unfurnished-studio": 5
  },
  "gelderland": {
    "1-bedroom-apartment": 64,
    "2-bedroom-apartment": 64,
    "2-bedroom-house": 19,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 31,
    "apartment-with-balcony": 74,
    "apartment-with-elevator": 45,
    "apartment-with-garden": 17,
    "apartment-with-laundry": 7,
    "apartment-with-private-parking": 29,
    "apartment-with-security": 6,
    "family-house": 55,
    "flat-for-students": 25,
    "furnished-1-bedroom-apartment": 20,
    "furnished-apartment": 40,
    "furnished-house": 10,
    "furnished-house-with-garden": 7,
    "furnished-room": 60,
    "furnished-studio": 5,
    "green-energy-apartment": 87,
    "green-energy-house": 37,
    "green-energy-room": 33,
    "green-energy-studio": 6,
    "house-for-rent": 60,
    "house-with-garden": 56,
    "house-with-private-parking": 9,
    "pet-friendly-apartment": 5,
    "renovated-apartment": 19,
    "room-for-students": 140,
    "room-with-laundry": 6,
    "student-housing": 165,
    "studio-for-rent": 20,
    "unfurnished-apartment": 111,
    "unfurnished-house": 50,
    "unfurnished-room": 101,
    "unfurnished-studio": 15
  },
  "geldrop-mierlo": {
    "furnished-studio": 5,
    "studio-for-rent": 5
  },
  "goes": {
    "family-house": 6,
    "green-energy-house": 5,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-house": 6
  },
  "groni-centrum": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 11,
    "apartment-with-balcony": 5,
    "apartment-with-garden": 6,
    "flat-for-students": 11,
    "furnished-apartment": 7,
    "green-energy-apartment": 8,
    "green-energy-room": 6,
    "renovated-apartment": 9,
    "room-for-students": 29,
    "student-housing": 40,
    "studio-for-rent": 8,
    "unfurnished-apartment": 23,
    "unfurnished-room": 33,
    "unfurnished-studio": 6
  },
  "groningen": {
    "1-bedroom-apartment": 31,
    "2-bedroom-apartment": 30,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 20,
    "apartment-with-elevator": 8,
    "apartment-with-garden": 15,
    "apartment-with-private-parking": 7,
    "family-house": 6,
    "flat-for-students": 33,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 16,
    "furnished-room": 26,
    "furnished-studio": 5,
    "green-energy-apartment": 26,
    "green-energy-house": 5,
    "green-energy-room": 38,
    "green-energy-studio": 6,
    "house-for-rent": 6,
    "renovated-apartment": 10,
    "room-for-students": 130,
    "room-with-laundry": 15,
    "student-housing": 166,
    "studio-for-rent": 26,
    "unfurnished-apartment": 54,
    "unfurnished-room": 129,
    "unfurnished-studio": 21
  },
  "groningen-province": {
    "1-bedroom-apartment": 40,
    "2-bedroom-apartment": 38,
    "2-bedroom-house": 19,
    "3-bedroom-apartment": 6,
    "3-bedroom-house": 18,
    "apartment-with-balcony": 25,
    "apartment-with-elevator": 12,
    "apartment-with-garden": 20,
    "apartment-with-private-parking": 11,
    "family-house": 44,
    "flat-for-students": 37,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 19,
    "furnished-room": 27,
    "furnished-studio": 5,
    "green-energy-apartment": 33,
    "green-energy-house": 29,
    "green-energy-room": 38,
    "green-energy-studio": 6,
    "house-for-rent": 46,
    "house-with-garden": 17,
    "house-with-private-parking": 6,
    "renovated-apartment": 13,
    "room-for-students": 132,
    "room-with-laundry": 15,
    "student-housing": 173,
    "studio-for-rent": 27,
    "unfurnished-apartment": 70,
    "unfurnished-house": 42,
    "unfurnished-room": 131,
    "unfurnished-studio": 22
  },
  "haarlem": {
    "1-bedroom-apartment": 27,
    "2-bedroom-apartment": 33,
    "apartment-with-balcony": 36,
    "apartment-with-elevator": 25,
    "apartment-with-private-parking": 23,
    "apartment-with-security": 9,
    "family-house": 7,
    "flat-for-students": 8,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 14,
    "green-energy-apartment": 60,
    "house-for-rent": 7,
    "house-with-garden": 6,
    "renovated-apartment": 14,
    "room-for-students": 12,
    "student-housing": 20,
    "studio-for-rent": 7,
    "unfurnished-apartment": 61,
    "unfurnished-house": 6,
    "unfurnished-room": 9
  },
  "haarlemmermeer": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 11,
    "apartment-with-elevator": 7,
    "family-house": 6,
    "furnished-apartment": 6,
    "furnished-room": 12,
    "green-energy-apartment": 10,
    "green-energy-house": 5,
    "green-energy-room": 7,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "room-for-students": 12,
    "student-housing": 14,
    "unfurnished-apartment": 10,
    "unfurnished-house": 5,
    "unfurnished-room": 5
  },
  "heerenveen": {
    "apartment-with-balcony": 5,
    "green-energy-apartment": 7,
    "unfurnished-apartment": 7
  },
  "heerhugowaard": {
    "unfurnished-apartment": 5
  },
  "heerlen": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 16,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 29,
    "apartment-with-elevator": 17,
    "apartment-with-private-parking": 6,
    "family-house": 7,
    "green-energy-apartment": 11,
    "house-for-rent": 7,
    "house-with-garden": 6,
    "room-for-students": 7,
    "student-housing": 8,
    "unfurnished-apartment": 36,
    "unfurnished-house": 7,
    "unfurnished-room": 5
  },
  "helmond": {
    "apartment-with-elevator": 5,
    "unfurnished-apartment": 5
  },
  "hengelo-o": {
    "furnished-room": 6,
    "room-for-students": 10,
    "student-housing": 14,
    "unfurnished-room": 5
  },
  "hillegersberg-schiebroek": {
    "unfurnished-apartment": 6
  },
  "hilversum": {
    "1-bedroom-apartment": 6,
    "2-bedroom-apartment": 5,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 11,
    "apartment-with-elevator": 6,
    "family-house": 6,
    "furnished-room": 7,
    "green-energy-apartment": 9,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "room-for-students": 6,
    "student-housing": 7,
    "unfurnished-apartment": 12
  },
  "hoogeveen": {
    "unfurnished-apartment": 7
  },
  "huizen": {
    "family-house": 5,
    "house-for-rent": 5,
    "unfurnished-house": 5
  },
  "ijsselmonde": {
    "2-bedroom-apartment": 9,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "furnished-room": 5,
    "student-housing": 5,
    "unfurnished-apartment": 6
  },
  "katendrecht": {
    "2-bedroom-apartment": 9,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 8,
    "green-energy-apartment": 14,
    "unfurnished-apartment": 15
  },
  "kerkrade": {
    "1-bedroom-apartment": 6,
    "2-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 9,
    "apartment-with-elevator": 5,
    "family-house": 6,
    "green-energy-apartment": 6,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-apartment": 15,
    "unfurnished-house": 5
  },
  "leeuwarden": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 14,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 21,
    "apartment-with-elevator": 15,
    "family-house": 9,
    "furnished-room": 7,
    "green-energy-apartment": 13,
    "green-energy-house": 7,
    "house-for-rent": 11,
    "house-with-garden": 10,
    "room-for-students": 19,
    "student-housing": 22,
    "studio-for-rent": 5,
    "unfurnished-apartment": 32,
    "unfurnished-house": 11,
    "unfurnished-room": 13
  },
  "leiden": {
    "1-bedroom-apartment": 23,
    "2-bedroom-apartment": 13,
    "3-bedroom-apartment": 5,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 18,
    "apartment-with-elevator": 17,
    "apartment-with-private-parking": 9,
    "apartment-with-security": 5,
    "family-house": 11,
    "flat-for-students": 11,
    "furnished-apartment": 6,
    "furnished-room": 5,
    "green-energy-apartment": 24,
    "green-energy-house": 6,
    "green-energy-room": 7,
    "green-energy-studio": 9,
    "house-for-rent": 11,
    "house-with-garden": 9,
    "room-for-students": 15,
    "student-housing": 28,
    "studio-for-rent": 14,
    "unfurnished-apartment": 38,
    "unfurnished-house": 9,
    "unfurnished-room": 12,
    "unfurnished-studio": 11
  },
  "leidschendam-voorburg": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 9,
    "3-bedroom-house": 6,
    "apartment-with-balcony": 10,
    "apartment-with-elevator": 11,
    "apartment-with-private-parking": 6,
    "family-house": 10,
    "green-energy-apartment": 11,
    "green-energy-house": 6,
    "house-for-rent": 10,
    "house-with-garden": 10,
    "unfurnished-apartment": 15,
    "unfurnished-house": 7
  },
  "lelys-stadshart": {
    "apartment-with-balcony": 6,
    "green-energy-apartment": 5
  },
  "lelystad": {
    "1-bedroom-apartment": 20,
    "2-bedroom-apartment": 12,
    "2-bedroom-house": 8,
    "3-bedroom-house": 5,
    "apartment-with-balcony": 11,
    "apartment-with-elevator": 9,
    "apartment-with-garden": 8,
    "apartment-with-laundry": 5,
    "apartment-with-private-parking": 16,
    "family-house": 15,
    "flat-for-students": 6,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 14,
    "green-energy-apartment": 27,
    "green-energy-house": 6,
    "house-for-rent": 15,
    "house-with-garden": 13,
    "house-with-private-parking": 7,
    "student-housing": 10,
    "unfurnished-apartment": 21,
    "unfurnished-house": 15
  },
  "limbu-weert": {
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 10,
    "green-energy-apartment": 9,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 11,
    "unfurnished-house": 5
  },
  "limburg": {
    "1-bedroom-apartment": 101,
    "1-bedroom-house": 5,
    "2-bedroom-apartment": 123,
    "2-bedroom-house": 14,
    "3-bedroom-apartment": 24,
    "3-bedroom-house": 58,
    "apartment-with-balcony": 154,
    "apartment-with-elevator": 113,
    "apartment-with-garden": 23,
    "apartment-with-laundry": 8,
    "apartment-with-private-parking": 30,
    "apartment-with-security": 6,
    "family-house": 90,
    "flat-for-students": 26,
    "furnished-1-bedroom-apartment": 18,
    "furnished-apartment": 34,
    "furnished-house": 10,
    "furnished-house-with-garden": 6,
    "furnished-room": 29,
    "furnished-studio": 15,
    "green-energy-apartment": 113,
    "green-energy-house": 50,
    "green-energy-room": 10,
    "house-for-rent": 100,
    "house-with-garden": 88,
    "house-with-private-parking": 17,
    "newly-built-apartment": 5,
    "pet-friendly-apartment": 14,
    "pet-friendly-house": 6,
    "renovated-apartment": 18,
    "room-for-students": 55,
    "room-with-laundry": 8,
    "student-housing": 82,
    "studio-for-rent": 32,
    "studio-with-laundry": 10,
    "studio-with-study-space": 7,
    "unfurnished-apartment": 233,
    "unfurnished-house": 90,
    "unfurnished-room": 33,
    "unfurnished-studio": 17
  },
  "lisse": {
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 5,
    "unfurnished-apartment": 6
  },
  "maastricht": {
    "1-bedroom-apartment": 27,
    "2-bedroom-apartment": 44,
    "3-bedroom-house": 7,
    "apartment-with-balcony": 47,
    "apartment-with-elevator": 29,
    "apartment-with-garden": 5,
    "apartment-with-private-parking": 5,
    "family-house": 14,
    "flat-for-students": 13,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 14,
    "furnished-room": 10,
    "furnished-studio": 12,
    "green-energy-apartment": 33,
    "green-energy-house": 5,
    "house-for-rent": 14,
    "house-with-garden": 12,
    "pet-friendly-apartment": 6,
    "renovated-apartment": 6,
    "room-for-students": 24,
    "room-with-laundry": 5,
    "student-housing": 37,
    "studio-for-rent": 16,
    "studio-with-laundry": 10,
    "studio-with-study-space": 7,
    "unfurnished-apartment": 68,
    "unfurnished-house": 11,
    "unfurnished-room": 19
  },
  "meerzicht": {
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 8,
    "apartment-with-security": 5,
    "unfurnished-apartment": 8
  },
  "meppel": {
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 5,
    "furnished-apartment": 5
  },
  "netherlands": {
    "1-bedroom-apartment": 1332,
    "1-bedroom-house": 59,
    "2-bedroom-apartment": 1669,
    "2-bedroom-house": 217,
    "3-bedroom-apartment": 434,
    "3-bedroom-house": 536,
    "4-bedroom-apartment": 54,
    "apartment-with-balcony": 1996,
    "apartment-with-elevator": 1183,
    "apartment-with-garden": 382,
    "apartment-with-laundry": 169,
    "apartment-with-private-parking": 524,
    "apartment-with-security": 189,
    "family-house": 978,
    "flat-for-students": 923,
    "furnished-1-bedroom-apartment": 438,
    "furnished-apartment": 1056,
    "furnished-house": 201,
    "furnished-house-with-garden": 159,
    "furnished-room": 837,
    "furnished-studio": 256,
    "green-energy-apartment": 2035,
    "green-energy-house": 556,
    "green-energy-room": 556,
    "green-energy-studio": 258,
    "house-for-rent": 1072,
    "house-with-garden": 903,
    "house-with-private-parking": 140,
    "newly-built-apartment": 98,
    "newly-built-house": 14,
    "pet-friendly-apartment": 125,
    "pet-friendly-house": 52,
    "renovated-apartment": 354,
    "renovated-house": 70,
    "room-for-students": 1545,
    "room-with-laundry": 175,
    "student-housing": 2522,
    "studio-for-rent": 614,
    "studio-with-balcony": 63,
    "studio-with-garden": 30,
    "studio-with-laundry": 166,
    "studio-with-study-space": 46,
    "unfurnished-apartment": 2626,
    "unfurnished-house": 871,
    "unfurnished-room": 974,
    "unfurnished-studio": 358
  },
  "nieuwe-westen": {
    "1-bedroom-apartment": 8,
    "2-bedroom-apartment": 7,
    "3-bedroom-apartment": 5,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "apartment-with-private-parking": 5,
    "furnished-1-bedroom-apartment": 5,
    "furnished-apartment": 13,
    "green-energy-apartment": 7,
    "renovated-apartment": 6,
    "room-for-students": 7,
    "student-housing": 11,
    "unfurnished-apartment": 11
  },
  "nieuwegein": {
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "green-energy-apartment": 9,
    "room-for-students": 5,
    "student-housing": 5,
    "unfurnished-apartment": 7
  },
  "nijmegen": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "apartment-with-private-parking": 9,
    "furnished-1-bedroom-apartment": 11,
    "furnished-apartment": 17,
    "furnished-room": 9,
    "green-energy-apartment": 16,
    "green-energy-room": 8,
    "renovated-apartment": 5,
    "room-for-students": 27,
    "student-housing": 31,
    "unfurnished-apartment": 10,
    "unfurnished-room": 19
  },
  "nijmegen-centrum": {
    "furnished-apartment": 7,
    "green-energy-apartment": 5,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-room": 5
  },
  "nijmegen-oost": {
    "room-for-students": 10,
    "student-housing": 11,
    "unfurnished-room": 8
  },
  "noord-brabant": {
    "1-bedroom-apartment": 233,
    "1-bedroom-house": 10,
    "2-bedroom-apartment": 197,
    "2-bedroom-house": 24,
    "3-bedroom-apartment": 37,
    "3-bedroom-house": 92,
    "apartment-with-balcony": 236,
    "apartment-with-elevator": 155,
    "apartment-with-garden": 50,
    "apartment-with-laundry": 26,
    "apartment-with-private-parking": 89,
    "apartment-with-security": 13,
    "family-house": 158,
    "flat-for-students": 286,
    "furnished-1-bedroom-apartment": 88,
    "furnished-apartment": 150,
    "furnished-house": 30,
    "furnished-house-with-garden": 23,
    "furnished-room": 150,
    "furnished-studio": 86,
    "green-energy-apartment": 247,
    "green-energy-house": 91,
    "green-energy-room": 193,
    "green-energy-studio": 92,
    "house-for-rent": 176,
    "house-with-garden": 149,
    "house-with-private-parking": 26,
    "newly-built-apartment": 15,
    "newly-built-house": 8,
    "pet-friendly-apartment": 11,
    "pet-friendly-house": 6,
    "renovated-apartment": 45,
    "renovated-house": 13,
    "room-for-students": 363,
    "room-with-laundry": 78,
    "student-housing": 659,
    "studio-for-rent": 212,
    "studio-with-balcony": 23,
    "studio-with-laundry": 71,
    "studio-with-study-space": 11,
    "unfurnished-apartment": 341,
    "unfurnished-house": 146,
    "unfurnished-room": 241,
    "unfurnished-studio": 126
  },
  "noord-holland": {
    "1-bedroom-apartment": 354,
    "1-bedroom-house": 8,
    "2-bedroom-apartment": 499,
    "2-bedroom-house": 57,
    "3-bedroom-apartment": 118,
    "3-bedroom-house": 120,
    "4-bedroom-apartment": 14,
    "apartment-with-balcony": 585,
    "apartment-with-elevator": 303,
    "apartment-with-garden": 108,
    "apartment-with-laundry": 42,
    "apartment-with-private-parking": 133,
    "apartment-with-security": 46,
    "family-house": 231,
    "flat-for-students": 171,
    "furnished-1-bedroom-apartment": 159,
    "furnished-apartment": 385,
    "furnished-house": 59,
    "furnished-house-with-garden": 48,
    "furnished-room": 224,
    "furnished-studio": 45,
    "green-energy-apartment": 636,
    "green-energy-house": 109,
    "green-energy-room": 103,
    "green-energy-studio": 51,
    "house-for-rent": 245,
    "house-with-garden": 207,
    "house-with-private-parking": 25,
    "newly-built-apartment": 34,
    "newly-built-house": 5,
    "pet-friendly-apartment": 40,
    "pet-friendly-house": 16,
    "renovated-apartment": 85,
    "renovated-house": 19,
    "room-for-students": 203,
    "room-with-laundry": 14,
    "student-housing": 382,
    "studio-for-rent": 82,
    "studio-with-balcony": 14,
    "studio-with-garden": 5,
    "studio-with-laundry": 13,
    "unfurnished-apartment": 651,
    "unfurnished-house": 186,
    "unfurnished-room": 51,
    "unfurnished-studio": 37
  },
  "noord-hoorn": {
    "1-bedroom-apartment": 21,
    "2-bedroom-apartment": 30,
    "2-bedroom-house": 5,
    "3-bedroom-house": 10,
    "apartment-with-balcony": 26,
    "apartment-with-elevator": 14,
    "apartment-with-garden": 10,
    "family-house": 18,
    "flat-for-students": 8,
    "furnished-1-bedroom-apartment": 9,
    "furnished-apartment": 19,
    "green-energy-apartment": 14,
    "house-for-rent": 18,
    "house-with-garden": 16,
    "student-housing": 8,
    "unfurnished-apartment": 36,
    "unfurnished-house": 14
  },
  "noord-medemblik": {
    "1-bedroom-apartment": 13,
    "2-bedroom-apartment": 11,
    "2-bedroom-house": 5,
    "3-bedroom-house": 8,
    "apartment-with-balcony": 13,
    "apartment-with-elevator": 6,
    "family-house": 15,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 13,
    "house-for-rent": 15,
    "house-with-garden": 14,
    "unfurnished-apartment": 12,
    "unfurnished-house": 13
  },
  "noord-veldhoven": {
    "3-bedroom-house": 5,
    "family-house": 8,
    "house-for-rent": 8,
    "house-with-garden": 7,
    "unfurnished-apartment": 6,
    "unfurnished-house": 7
  },
  "noord-waterland": {
    "1-bedroom-apartment": 8,
    "apartment-with-balcony": 6,
    "apartment-with-garden": 7,
    "furnished-apartment": 7,
    "green-energy-apartment": 6,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 7
  },
  "noord-zandvoort": {
    "flat-for-students": 5,
    "green-energy-apartment": 5,
    "student-housing": 6
  },
  "nude": {
    "room-for-students": 9,
    "student-housing": 11,
    "unfurnished-room": 5
  },
  "oldambt": {
    "house-for-rent": 5,
    "unfurnished-apartment": 5,
    "unfurnished-house": 5
  },
  "oss": {
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 7,
    "apartment-with-elevator": 5,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 8
  },
  "oude-noorden": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 10,
    "flat-for-students": 5,
    "furnished-apartment": 7,
    "renovated-apartment": 5,
    "room-for-students": 5,
    "student-housing": 11,
    "unfurnished-apartment": 7
  },
  "overi-zwolle": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 14,
    "3-bedroom-house": 8,
    "apartment-with-balcony": 18,
    "apartment-with-elevator": 14,
    "apartment-with-private-parking": 8,
    "family-house": 10,
    "flat-for-students": 11,
    "furnished-apartment": 6,
    "green-energy-apartment": 24,
    "green-energy-house": 10,
    "house-for-rent": 10,
    "house-with-garden": 10,
    "room-for-students": 19,
    "student-housing": 30,
    "studio-for-rent": 5,
    "unfurnished-apartment": 33,
    "unfurnished-house": 9,
    "unfurnished-room": 28
  },
  "overijssel": {
    "1-bedroom-apartment": 49,
    "2-bedroom-apartment": 42,
    "2-bedroom-house": 12,
    "3-bedroom-apartment": 19,
    "3-bedroom-house": 34,
    "4-bedroom-apartment": 5,
    "apartment-with-balcony": 57,
    "apartment-with-elevator": 32,
    "apartment-with-garden": 12,
    "apartment-with-private-parking": 18,
    "apartment-with-security": 6,
    "family-house": 52,
    "flat-for-students": 51,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 19,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "furnished-room": 53,
    "furnished-studio": 16,
    "green-energy-apartment": 51,
    "green-energy-house": 28,
    "green-energy-room": 36,
    "green-energy-studio": 7,
    "house-for-rent": 59,
    "house-with-garden": 50,
    "house-with-private-parking": 5,
    "renovated-apartment": 12,
    "room-for-students": 134,
    "room-with-laundry": 7,
    "student-housing": 196,
    "studio-for-rent": 36,
    "studio-with-laundry": 8,
    "unfurnished-apartment": 102,
    "unfurnished-house": 50,
    "unfurnished-room": 106,
    "unfurnished-studio": 20
  },
  "paleiskwartier": {
    "2-bedroom-apartment": 14,
    "apartment-with-balcony": 15,
    "apartment-with-private-parking": 6,
    "furnished-apartment": 7,
    "green-energy-apartment": 16,
    "unfurnished-apartment": 10
  },
  "prins-alexander": {
    "apartment-with-balcony": 6,
    "flat-for-students": 5,
    "furnished-room": 5,
    "green-energy-apartment": 5,
    "room-for-students": 6,
    "student-housing": 11,
    "studio-for-rent": 5,
    "unfurnished-apartment": 5
  },
  "purmerend": {
    "1-bedroom-apartment": 49,
    "2-bedroom-apartment": 54,
    "2-bedroom-house": 16,
    "3-bedroom-apartment": 12,
    "3-bedroom-house": 13,
    "apartment-with-balcony": 88,
    "apartment-with-elevator": 54,
    "apartment-with-garden": 8,
    "apartment-with-laundry": 7,
    "apartment-with-security": 9,
    "family-house": 31,
    "flat-for-students": 12,
    "furnished-1-bedroom-apartment": 16,
    "furnished-apartment": 29,
    "green-energy-apartment": 100,
    "green-energy-house": 25,
    "house-for-rent": 31,
    "house-with-garden": 30,
    "newly-built-apartment": 5,
    "student-housing": 14,
    "unfurnished-apartment": 92,
    "unfurnished-house": 30
  },
  "roermond": {
    "1-bedroom-apartment": 12,
    "2-bedroom-apartment": 7,
    "apartment-with-balcony": 14,
    "apartment-with-elevator": 13,
    "flat-for-students": 5,
    "green-energy-apartment": 9,
    "student-housing": 5,
    "unfurnished-apartment": 20
  },
  "roosendaal": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 6,
    "apartment-with-elevator": 5,
    "family-house": 5,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 11
  },
  "rotte-delfshaven": {
    "1-bedroom-apartment": 19,
    "2-bedroom-apartment": 21,
    "3-bedroom-apartment": 8,
    "apartment-with-balcony": 22,
    "apartment-with-elevator": 13,
    "apartment-with-garden": 9,
    "apartment-with-private-parking": 7,
    "flat-for-students": 15,
    "furnished-1-bedroom-apartment": 12,
    "furnished-apartment": 27,
    "furnished-room": 15,
    "green-energy-apartment": 20,
    "green-energy-room": 8,
    "renovated-apartment": 9,
    "room-for-students": 27,
    "student-housing": 42,
    "unfurnished-apartment": 30,
    "unfurnished-room": 14
  },
  "rotte-feijenoord": {
    "1-bedroom-apartment": 25,
    "2-bedroom-apartment": 35,
    "3-bedroom-apartment": 13,
    "4-bedroom-apartment": 6,
    "apartment-with-balcony": 47,
    "apartment-with-elevator": 25,
    "apartment-with-laundry": 6,
    "apartment-with-private-parking": 12,
    "apartment-with-security": 8,
    "flat-for-students": 16,
    "furnished-1-bedroom-apartment": 10,
    "furnished-apartment": 25,
    "furnished-room": 9,
    "green-energy-apartment": 52,
    "green-energy-room": 5,
    "newly-built-apartment": 5,
    "renovated-apartment": 8,
    "room-for-students": 14,
    "student-housing": 32,
    "studio-for-rent": 7,
    "unfurnished-apartment": 56,
    "unfurnished-room": 5
  },
  "rotte-noord": {
    "1-bedroom-apartment": 16,
    "2-bedroom-apartment": 18,
    "3-bedroom-apartment": 12,
    "apartment-with-balcony": 35,
    "apartment-with-garden": 11,
    "flat-for-students": 13,
    "furnished-1-bedroom-apartment": 7,
    "furnished-apartment": 21,
    "green-energy-apartment": 12,
    "green-energy-room": 5,
    "renovated-apartment": 13,
    "room-for-students": 14,
    "student-housing": 28,
    "unfurnished-apartment": 33,
    "unfurnished-room": 11
  },
  "rotterdam": {
    "1-bedroom-apartment": 115,
    "2-bedroom-apartment": 194,
    "3-bedroom-apartment": 65,
    "3-bedroom-house": 7,
    "4-bedroom-apartment": 17,
    "apartment-with-balcony": 247,
    "apartment-with-elevator": 130,
    "apartment-with-garden": 36,
    "apartment-with-laundry": 17,
    "apartment-with-private-parking": 44,
    "apartment-with-security": 38,
    "family-house": 14,
    "flat-for-students": 112,
    "furnished-1-bedroom-apartment": 53,
    "furnished-apartment": 155,
    "furnished-house": 12,
    "furnished-house-with-garden": 8,
    "furnished-room": 69,
    "furnished-studio": 32,
    "green-energy-apartment": 200,
    "green-energy-house": 5,
    "green-energy-room": 36,
    "green-energy-studio": 23,
    "house-for-rent": 16,
    "house-with-garden": 12,
    "newly-built-apartment": 14,
    "pet-friendly-apartment": 22,
    "renovated-apartment": 57,
    "room-for-students": 117,
    "room-with-laundry": 17,
    "student-housing": 234,
    "studio-for-rent": 51,
    "studio-with-laundry": 12,
    "studio-with-study-space": 5,
    "unfurnished-apartment": 257,
    "unfurnished-room": 61,
    "unfurnished-studio": 19
  },
  "s-her-binnenstad": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 5,
    "furnished-apartment": 7,
    "renovated-apartment": 6,
    "unfurnished-apartment": 5
  },
  "s-her-west": {
    "1-bedroom-apartment": 7,
    "2-bedroom-apartment": 17,
    "apartment-with-balcony": 21,
    "apartment-with-elevator": 7,
    "apartment-with-private-parking": 7,
    "furnished-apartment": 7,
    "green-energy-apartment": 22,
    "unfurnished-apartment": 19
  },
  "s-hertogenbosch": {
    "1-bedroom-apartment": 22,
    "2-bedroom-apartment": 26,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 28,
    "apartment-with-elevator": 15,
    "apartment-with-garden": 5,
    "apartment-with-private-parking": 8,
    "family-house": 5,
    "furnished-apartment": 16,
    "green-energy-apartment": 36,
    "green-energy-house": 5,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "renovated-apartment": 14,
    "room-for-students": 7,
    "student-housing": 10,
    "unfurnished-apartment": 38,
    "unfurnished-room": 5
  },
  "schagen": {
    "green-energy-apartment": 5,
    "unfurnished-apartment": 5
  },
  "schiedam": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 9,
    "apartment-with-balcony": 5,
    "apartment-with-garden": 6,
    "family-house": 5,
    "furnished-apartment": 6,
    "green-energy-apartment": 13,
    "green-energy-room": 5,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "renovated-apartment": 6,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-apartment": 12,
    "unfurnished-house": 5,
    "unfurnished-room": 5
  },
  "sdwest-frysln": {
    "2-bedroom-apartment": 8,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 6,
    "green-energy-apartment": 8,
    "unfurnished-apartment": 10
  },
  "sittard-geleen": {
    "1-bedroom-apartment": 11,
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 8,
    "apartment-with-elevator": 6,
    "family-house": 7,
    "green-energy-apartment": 9,
    "house-for-rent": 7,
    "house-with-garden": 7,
    "renovated-apartment": 5,
    "room-for-students": 6,
    "student-housing": 10,
    "unfurnished-apartment": 17,
    "unfurnished-house": 7
  },
  "smallingerland": {
    "apartment-with-balcony": 9,
    "unfurnished-apartment": 10
  },
  "spijkerkwartier": {
    "room-for-students": 6,
    "student-housing": 7,
    "unfurnished-room": 6
  },
  "stede-broec": {
    "3-bedroom-house": 6,
    "family-house": 13,
    "furnished-apartment": 5,
    "house-for-rent": 14,
    "house-with-garden": 14,
    "unfurnished-house": 12
  },
  "terneuzen": {
    "apartment-with-balcony": 6,
    "unfurnished-apartment": 6
  },
  "tilbu-groenewoud": {
    "3-bedroom-house": 6,
    "family-house": 6,
    "house-for-rent": 6,
    "house-with-garden": 6,
    "unfurnished-house": 6
  },
  "tilburg": {
    "1-bedroom-apartment": 26,
    "2-bedroom-apartment": 22,
    "3-bedroom-apartment": 7,
    "3-bedroom-house": 19,
    "apartment-with-balcony": 31,
    "apartment-with-elevator": 25,
    "apartment-with-private-parking": 7,
    "family-house": 22,
    "flat-for-students": 28,
    "furnished-1-bedroom-apartment": 8,
    "furnished-apartment": 14,
    "furnished-room": 10,
    "furnished-studio": 6,
    "green-energy-apartment": 24,
    "green-energy-house": 14,
    "green-energy-room": 14,
    "green-energy-studio": 6,
    "house-for-rent": 24,
    "house-with-garden": 22,
    "house-with-private-parking": 5,
    "renovated-apartment": 7,
    "room-for-students": 45,
    "student-housing": 75,
    "studio-for-rent": 30,
    "studio-with-balcony": 8,
    "unfurnished-apartment": 44,
    "unfurnished-house": 23,
    "unfurnished-room": 42,
    "unfurnished-studio": 24
  },
  "utrecht": {
    "1-bedroom-apartment": 36,
    "2-bedroom-apartment": 55,
    "3-bedroom-apartment": 10,
    "3-bedroom-house": 8,
    "apartment-with-balcony": 49,
    "apartment-with-elevator": 17,
    "apartment-with-garden": 8,
    "apartment-with-private-parking": 33,
    "family-house": 14,
    "flat-for-students": 46,
    "furnished-1-bedroom-apartment": 9,
    "furnished-apartment": 33,
    "furnished-house": 9,
    "furnished-house-with-garden": 7,
    "furnished-room": 34,
    "furnished-studio": 11,
    "green-energy-apartment": 68,
    "green-energy-house": 8,
    "green-energy-room": 10,
    "green-energy-studio": 7,
    "house-for-rent": 19,
    "house-with-garden": 15,
    "renovated-apartment": 12,
    "room-for-students": 80,
    "student-housing": 129,
    "studio-for-rent": 33,
    "studio-with-study-space": 6,
    "unfurnished-apartment": 76,
    "unfurnished-house": 10,
    "unfurnished-room": 64,
    "unfurnished-studio": 22
  },
  "utrecht-province": {
    "1-bedroom-apartment": 44,
    "2-bedroom-apartment": 85,
    "3-bedroom-apartment": 21,
    "3-bedroom-house": 20,
    "apartment-with-balcony": 76,
    "apartment-with-elevator": 36,
    "apartment-with-garden": 11,
    "apartment-with-laundry": 6,
    "apartment-with-private-parking": 48,
    "apartment-with-security": 5,
    "family-house": 43,
    "flat-for-students": 58,
    "furnished-1-bedroom-apartment": 12,
    "furnished-apartment": 47,
    "furnished-house": 20,
    "furnished-house-with-garden": 17,
    "furnished-room": 48,
    "furnished-studio": 16,
    "green-energy-apartment": 98,
    "green-energy-house": 22,
    "green-energy-room": 19,
    "green-energy-studio": 10,
    "house-for-rent": 51,
    "house-with-garden": 37,
    "house-with-private-parking": 10,
    "pet-friendly-apartment": 6,
    "pet-friendly-house": 5,
    "renovated-apartment": 12,
    "room-for-students": 115,
    "student-housing": 177,
    "studio-for-rent": 42,
    "studio-with-balcony": 5,
    "studio-with-garden": 7,
    "studio-with-laundry": 5,
    "studio-with-study-space": 6,
    "unfurnished-apartment": 113,
    "unfurnished-house": 31,
    "unfurnished-room": 94,
    "unfurnished-studio": 26
  },
  "venlo": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 6,
    "apartment-with-elevator": 6,
    "furnished-room": 5,
    "room-for-students": 9,
    "student-housing": 9,
    "unfurnished-apartment": 7
  },
  "vlissingen": {
    "2-bedroom-apartment": 5,
    "apartment-with-balcony": 5,
    "room-for-students": 5,
    "student-housing": 5,
    "unfurnished-apartment": 6
  },
  "wagen-noordwest": {
    "furnished-room": 5,
    "room-for-students": 12,
    "student-housing": 12,
    "unfurnished-room": 7
  },
  "wageningen": {
    "flat-for-students": 6,
    "furnished-room": 23,
    "green-energy-room": 9,
    "room-for-students": 51,
    "student-housing": 57,
    "studio-for-rent": 5,
    "unfurnished-room": 28,
    "unfurnished-studio": 5
  },
  "wassenaar": {
    "2-bedroom-apartment": 6,
    "apartment-with-balcony": 5,
    "apartment-with-elevator": 6,
    "family-house": 5,
    "green-energy-apartment": 9,
    "house-for-rent": 5,
    "house-with-garden": 5,
    "unfurnished-apartment": 10,
    "unfurnished-house": 5
  },
  "weesp-binnenstad": {
    "1-bedroom-apartment": 20,
    "2-bedroom-apartment": 38,
    "3-bedroom-apartment": 16,
    "apartment-with-balcony": 49,
    "apartment-with-elevator": 15,
    "apartment-with-garden": 13,
    "apartment-with-laundry": 5,
    "apartment-with-private-parking": 10,
    "flat-for-students": 18,
    "furnished-1-bedroom-apartment": 17,
    "furnished-apartment": 40,
    "furnished-room": 16,
    "furnished-studio": 5,
    "green-energy-apartment": 46,
    "green-energy-room": 6,
    "green-energy-studio": 5,
    "renovated-apartment": 6,
    "room-for-students": 12,
    "student-housing": 30,
    "studio-for-rent": 6,
    "unfurnished-apartment": 42
  },
  "zaanstad": {
    "1-bedroom-apartment": 5,
    "2-bedroom-apartment": 20,
    "apartment-with-balcony": 15,
    "apartment-with-elevator": 10,
    "apartment-with-private-parking": 9,
    "family-house": 6,
    "furnished-apartment": 5,
    "green-energy-apartment": 12,
    "house-for-rent": 8,
    "newly-built-apartment": 6,
    "room-for-students": 5,
    "student-housing": 6,
    "unfurnished-apartment": 21,
    "unfurnished-house": 6
  },
  "zeeland": {
    "1-bedroom-apartment": 15,
    "1-bedroom-house": 6,
    "2-bedroom-apartment": 24,
    "2-bedroom-house": 9,
    "3-bedroom-house": 18,
    "apartment-with-balcony": 30,
    "apartment-with-elevator": 22,
    "apartment-with-garden": 5,
    "family-house": 27,
    "furnished-apartment": 7,
    "furnished-house": 6,
    "green-energy-apartment": 30,
    "green-energy-house": 19,
    "house-for-rent": 33,
    "house-with-garden": 28,
    "room-for-students": 6,
    "student-housing": 9,
    "unfurnished-apartment": 36,
    "unfurnished-house": 27
  },
  "zeist": {
    "room-for-students": 11,
    "student-housing": 16,
    "unfurnished-room": 10
  },
  "zoetermeer": {
    "1-bedroom-apartment": 15,
    "2-bedroom-apartment": 11,
    "3-bedroom-house": 9,
    "apartment-with-balcony": 21,
    "apartment-with-elevator": 19,
    "apartment-with-laundry": 5,
    "apartment-with-security": 7,
    "family-house": 12,
    "green-energy-apartment": 19,
    "green-energy-house": 8,
    "house-for-rent": 12,
    "house-with-garden": 12,
    "renovated-apartment": 5,
    "student-housing": 5,
    "unfurnished-apartment": 30,
    "unfurnished-house": 11
  },
  "zuid-holland": {
    "1-bedroom-apartment": 333,
    "1-bedroom-house": 8,
    "2-bedroom-apartment": 469,
    "2-bedroom-house": 16,
    "3-bedroom-apartment": 151,
    "3-bedroom-house": 83,
    "4-bedroom-apartment": 28,
    "apartment-with-balcony": 594,
    "apartment-with-elevator": 358,
    "apartment-with-garden": 94,
    "apartment-with-laundry": 66,
    "apartment-with-private-parking": 131,
    "apartment-with-security": 90,
    "family-house": 146,
    "flat-for-students": 221,
    "furnished-1-bedroom-apartment": 99,
    "furnished-apartment": 303,
    "furnished-house": 43,
    "furnished-house-with-garden": 34,
    "furnished-room": 169,
    "furnished-studio": 57,
    "green-energy-apartment": 569,
    "green-energy-house": 91,
    "green-energy-room": 73,
    "green-energy-studio": 67,
    "house-for-rent": 157,
    "house-with-garden": 137,
    "house-with-private-parking": 30,
    "newly-built-apartment": 24,
    "pet-friendly-apartment": 41,
    "pet-friendly-house": 9,
    "renovated-apartment": 132,
    "renovated-house": 17,
    "room-for-students": 265,
    "room-with-laundry": 38,
    "student-housing": 496,
    "studio-for-rent": 130,
    "studio-with-balcony": 10,
    "studio-with-laundry": 41,
    "studio-with-study-space": 14,
    "unfurnished-apartment": 738,
    "unfurnished-house": 114,
    "unfurnished-room": 130,
    "unfurnished-studio": 73
  },
  "zuid-noordwijk": {
    "3-bedroom-house": 5,
    "family-house": 5,
    "house-for-rent": 5
  },
  "zuid-rijswijk": {
    "1-bedroom-apartment": 8,
    "2-bedroom-apartment": 13,
    "3-bedroom-apartment": 6,
    "apartment-with-balcony": 22,
    "apartment-with-elevator": 15,
    "apartment-with-private-parking": 5,
    "green-energy-apartment": 15,
    "renovated-apartment": 5,
    "unfurnished-apartment": 27
  },
  "zuidplein": {
    "2-bedroom-apartment": 6,
    "unfurnished-apartment": 7
  },
  "zutphen": {
    "2-bedroom-apartment": 5,
    "2-bedroom-house": 5,
    "family-house": 8,
    "house-for-rent": 8,
    "house-with-garden": 8,
    "unfurnished-apartment": 6,
    "unfurnished-house": 8
  }
};